//
// REGISTER PLUGINS

import gsap from "gsap";

//
gsap.registerPlugin(ScrollTrigger);

//
// DECLARE VARS
//
let scroll;

//
// SELECTORS
//
const body = document.body;
const select = (e) => document.querySelector(e);
const selectAll = (e) => document.querySelectorAll(e);

//

//
// GLOBAL INIT
//

initPageTransitions();

//
// USEFUL FUNCS
//
function getRandomBetween(min, max) {
  return Math.random() * (max - min) + min;
}
/*
function initMap() {
  try {
      var location = {lat: 41.1406219, lng: -8.6156761};
      let map = new google.maps.Map(document.getElementById('map'), {
          center: location,
          zoom: 17,
      });
      let marker = new google.maps.Marker({
          position: location,
          map: map
      });
      console.log('Map initialized successfully.');
  } catch (error) {
      console.error('Error initializing map:', error);
  }
}
const google = select('#map');
function loadGoogleMapsAPI(callback) {
  if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
      callback();
      console.log('Google maps already loaded.');
  } else {
      console.log('nope.');
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBpLWeisMb8qyNAZor0AamBjYEnbcIwlaw&callback=initMap';
      script.async = true;
      script.defer = true;
      window.initMap = callback;
      document.head.appendChild(script);
  }
}
  */


function pageTransitionIn({ container }) {
  // timeline to stretch the loader over the whole screen
  const tl = gsap.timeline({
    defaults: {
      duration: .5,
      ease: 'expo.Out'
    }
  });

  tl
    .to(container, { y: 18, autoAlpha: 0 }, 0);
  return tl;
}

function pageTransitionOut({ container }) {
  // timeline to move loader away down
  const tl = gsap.timeline({
    defaults: {
      duration: 1,
      ease: 'expo.In'
    },
    onComplete: () => initScript()
  });
  // gsap.to("#menu-bg", {
  // 	y: 0,
  // 	delay: 1,
  // 	ease: 'Expo.easeInOut',
  // 	duration: 1
  // });
  tl
    .from(container, { y: -18, autoAlpha: 0, delay: 0 }, 0);
  return tl;
}

function initPageTransitions() {
  var templateUrl = "http://localhost:3000/contact-us/";
  // do something before the transition starts
  barba.hooks.before(() => {
    select('html').classList.add('is-transitioning');
  });
  // do something after the transition finishes
  barba.hooks.after(() => {
    select('html').classList.remove('is-transitioning');
  });
  // scroll to the top of the page
  barba.hooks.enter(() => {
    console.log('enter');
  });

  // Add this before any other Barba configuration
  document.addEventListener('click', function(event) {
    const link = event.target.closest('a');
    if (!link) return;

    if (link.target === '_blank' ||
        link.href.toLowerCase().endsWith('.pdf') ||
        link.href.toLowerCase().endsWith('.doc') ||
        link.href.toLowerCase().endsWith('.docx')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation(); // Stop all other event handlers
      const newWindow = window.open();
      if (newWindow) {
        newWindow.opener = null;
        newWindow.location = link.href;
      }
      return false;
    }
  }, { capture: true, passive: false });

  barba.init({
    sync: true,
    debug: false,
    timeout: 7000,
    prevent: ({ el }) => {
      // Check if it's a link element
      if (el.tagName === 'A') {
        // Prevent Barba from handling _blank links
        if (el.target === '_blank' || el.getAttribute('target') === '_blank') {
          return true;
        }
        // Check for PDF or other document links
        if (el.href.toLowerCase().endsWith('.pdf') ||
            el.href.toLowerCase().endsWith('.doc') ||
            el.href.toLowerCase().endsWith('.docx')) {
          return true;
        }
      }
      // Also prevent if it has the prevent class
      return el.classList && el.classList.contains('prevent');
    },
    transitions: [{
      name: 'overlay-transition',
      once(data) {
        // do something once on the initial page load
        initSmoothScroll(data.next.container);
        loadScripts();
        initParallaxScrolling();

      },
      async leave(data) {
        // animate loading screen in
        pageTransitionIn(data.current);
        await delay(500);
        data.current.container.remove();
      },
      async beforeEnter(data) {
        ScrollTrigger.getAll().forEach(t => t.kill());
        initSmoothScroll(data.next.container);
        loadScripts();
        window.scrollTo(0, 0);
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);

      },
      async enter(data) {
        // animate loading screen away
        pageTransitionOut(data.next);
        // document.querySelector('header.fixed').classList.remove("nav-transparent");
      },
      async after(data) {
        var alturaConteudoOnLoad = select(".transition-container").offsetHeight;

        // gsap.to("#proj-loading", {
        // 	opacity: 1,
        // 	ease: "expo.out",
        // });

        Promise.all(Array.from(document.images).filter(img => !img.complete).map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
          console.log('images finished loading');
          // gsap.to("#proj-loading", {
          // 	opacity: 0,
          // 	duration: 1,
          // 	ease: "expo.out",
          // });
        });

      }

    }],
    views: [
      {
        namespace: "home",
        afterEnter(data) {

          document.querySelector('header.fixed').classList.add("nav-transparent");



          //
          // SWIPER
          //
          // var swiper = new Swiper(".mySwiper", { });


        }
      }, {
        namespace: "single",
        afterEnter(data) {
          console.log(data);

          let swiper = new Swiper(".swiper", {
            loop: true,
            slidesPerView: 2,
            spaceBetween: 20,
            grabCursor: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: true,
            },
          });


        }

      }, {
        namespace: "gallery",
        afterEnter(data) {
          console.log(data);

          const masonryItems = document.querySelectorAll('.masonry-item img');
          const rowHeight = 460; // Adjust row height as necessary

          masonryItems.forEach(img => {
            if (img.complete) {
              adjustImageClass(img);
            } else {
              img.addEventListener('load', function () {
                adjustImageClass(img);
              });
            }
          });

          function adjustImageClass(img) {
            const aspectRatio = img.naturalWidth / img.naturalHeight;
            const item = img.parentElement;

            if (aspectRatio > 1) {
              item.style.flex = `1 1 auto`;
              item.style.height = `${rowHeight}px`;
              item.style.width = `${rowHeight * aspectRatio}px`;
            } else {
              item.style.flex = `1 1 auto`;
              item.style.height = `${rowHeight}px`;
              //item.style.width = `${rowHeight / aspectRatio}px`;
              item.style.width = `${rowHeight * aspectRatio}px`;
            }
          }

          var map = new mapboxgl.Map({
            container: 'map',
            style: 'https://maputnik.github.io/osm-liberty/style.json',
            center: [8.538961, 47.372476],
            zoom: 5,
            hash: true
          });


        } // afterEnter

      }, {
        namespace: 'contact',
        afterEnter(data) {
          // if (document.querySelector('#map')) {

          var thisDelay = 0;
          gsap.utils.toArray('.marker').forEach(marker => {


            gsap.fromTo(marker, {
              scale: .25,
            }, {
              scale: 1,
              duration: 1,
              delay: thisDelay,
              repeat: -1,
              yoyo: true,
              ease: "power2.inOut",
            });
            thisDelay += .75;
          });


        } // afterEnter
      }
    ]
  });

  // Keep the existing click handler as a backup
  document.addEventListener('click', function(event) {
    const link = event.target.closest('a');
    if (!link) return;

    if (link.target === '_blank') {
      event.preventDefault();
      event.stopPropagation();
      window.open(link.href, '_blank');
      return false;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('#map')) {
      console.log('Document loaded with map element. Initializing map...');
      // loadGoogleMapsAPI(initMap);
    }
  });



  function initSmoothScroll(container) {
    //
    // LENIS
    //
    const lenis = new Lenis()

    lenis.on('scroll', (e) => {
      const navbar = document.querySelector('.main-nav');
      const content = document.querySelector('.transition-container');

      // Only proceed if both navbar and content exist
      if (navbar && content) {
        if (e.animatedScroll >= 40) {
          navbar.style.position = 'fixed';
          navbar.style.zIndex = '4';
          content.style.marginTop = '84px';
        } else {
          navbar.style.position = 'relative';
          content.style.marginTop = '0';
        }
      }
    })

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)


    //
    // Materials > scrollto animation
    //

    var btnStone = document.querySelector('#btn-stone');
    if (typeof (btnStone) != 'undefined' && btnStone != null) {
      btnStone.addEventListener('click', () => {
        lenis.scrollTo(1600);
      });

      /*
      var element = document.getElementById('myElement');
      var rect = element.getBoundingClientRect();
      var yPosition = rect.top + window.pageYOffset;
      console.log(yPosition);
      */

    }

    //
    // MODAL
    //
    const openModalLink = document.getElementById('open-modal');
    if (typeof (openModalLink) != 'undefined' && openModalLink != null) {


      const closeModalButton = document.getElementById('close-modal');
      const modal = document.getElementById('modal');

      openModalLink.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent default anchor tag behavior
        modal.classList.add('active');
      });

      closeModalButton.addEventListener('click', () => {
        modal.classList.remove('active');
      });

      // Alternatively, close the modal when clicking outside the modal content
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          modal.classList.remove('active');
        }
      });
    }



  } // initSmoothScroll

  function loadScripts() {
    // document.querySelectorAll(".prevent-barba").forEach(item=>item.setAttribute('data-barba-prevent','self'));
    // document.querySelectorAll("#menu-item-6 a").forEach(item=>item.setAttribute('data-barba-prevent','self'));

    // document.querySelectorAll("#menu-item-10 a").border = '12px solid red';

    // reservationsLink.style.border = '2px solid red';
    // if (typeof(reservationsLink) != 'undefined' && reservationsLink != null) {
    //   reservationsLink.addEventListener('click', (event) => {
    //     event.preventDefault(); // Prevent default anchor tag behavior
    //     event.setAttribute('data-barba-prevent','self');
    //   });
    // }
    // const langLink = document.querySelector('#menu-right-menu li:last-child a');
    // // langLink.style.border = '2px solid red';
    // // langLink.setAttribute('data-barba-prevent','self');
    setTimeout(() => {
      const reservationsLink = document.querySelector('#menu-right-menu li:first-child a');
      if (typeof (reservationsLink) != 'undefined' && reservationsLink != null) {
        reservationsLink.classList.add('prevent-barba');
      }
      const langLink = document.querySelector('#menu-right-menu li:last-child a');
      if (typeof (langLink) != 'undefined' && langLink != null) {
        // langLink.style.border = '2px solid red';
        langLink.removeAttribute(langLink.attributes[0].lang);

        langLink.classList.add('prevent-barba');
      }
      // var langLink = Array.from(langLink.attributes);

      // // Loop through each attribute and remove it if it's not 'href' or 'class'
      // langLink.forEach(function(attr) {
      //     if (attr.name !== 'href' && attr.name !== 'class') {
      //       langLink.removeAttribute(attr.name);
      //     }
      // });

      const popupLinks = document.querySelectorAll('.sg-popup-builder-content a');
      if (popupLinks.length > 0) {
        popupLinks.forEach(link => {
          link.classList.add('prevent-barba');
          link.setAttribute('data-barba-prevent', 'self');
        });
      }

      var langSwitchLink = document.querySelector('#menu-item-130-pt a, #menu-item-132-pt a');

      // Check if the element exists
      if (langSwitchLink) {
        // Add the data-prevent-self attribute
        langSwitchLink.setAttribute('data-barba-prevent', 'self');
      }

      // Add an event listener to the document for clicks on links
      document.addEventListener('click', function (event) {
        const link = event.target.closest('a');
        if (!link) return;

        // Handle target="_blank" links
        if (link.target === '_blank') {
          event.preventDefault();
          window.open(link.href, '_blank');
          return;
        }

        // Handle existing data-barba-prevent="self" links
        if (link.getAttribute('data-barba-prevent') === 'self') {
          event.preventDefault();
          window.location.href = link.href;
        }
      });
    }, 500);
    // langLink.classList.add('prevent');

    const burger = document.querySelector(".burger-icon");
    const menu = document.querySelector(".burger-menu");
    const menuBg = menu.querySelector(".menu-bg");
    const menuLinks = document.querySelectorAll(".menu-item");

    let isMenuOpen = false;

    burger.addEventListener("click", () => {
      toggleMenu();
    });

    menuLinks.forEach(link => {
      link.addEventListener("click", (event) => {
        // event.preventDefault();
        // console.log("Menu link clicked:", link);

        if (isMenuOpen) {
          toggleMenu();
        }
      });
    });

    function toggleMenu() {
      if (!isMenuOpen) {
        burger.classList.add("opened");
        menuBg.classList.add("opened");
        menu.style.visibility = 'visible';
        gsap.to(menu, {
          x: 0,
          duration: .75,
          ease: 'expo.inOut',
        });
      } else {
        burger.classList.remove("opened");
        menuBg.classList.remove("opened");
        gsap.to(menu, {
          x: "100%",
          duration: .75,
          ease: 'expo.inOut',
          onComplete: () => {
            menu.style.visibility = 'hidden';
          }
        });
      }
      isMenuOpen = !isMenuOpen;
    }


    //
    // HOME CALENDAR
    //

    setTimeout(() => {
      var dateInputs = document.querySelectorAll('.Date');
      if (typeof (dateInputs) != 'undefined' && dateInputs != null) {
        dateInputs.forEach(function (dateInput) {
          var currentValue = dateInput.value;
          if (currentValue && typeof currentValue === 'string') {
            var parts = currentValue.split(',');
            if (parts.length === 2) {
              var dateParts = parts[1].trim().split('/');
              if (dateParts.length === 3) {
                var formattedDate = dateParts[0] + '.' + dateParts[1];
                dateInput.value = formattedDate;
              }
            }
          }
        });
      } // typeof dateInputs
    }, 200);

  } // loadScripts
}

function delay(n) {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
}



/**
 * Fire all scripts on page load
 */
function initScript() {
  select('body').classList.remove('is-loading');
  initParallaxScrolling();
}

//initPageTransitions();



const anims = [];
function initParallaxScrolling() {
  gsap.utils.toArray('#rotate-this').forEach(section => {
    var thisImage = section.querySelector('img');
    gsap.to(thisImage, {
      rotate: 120,
      ease: 'Expo.Out',
      scrollTrigger: {
        trigger: section,
        toggleClass: 'enable',
        start: '0% 100%',
        end: "+=200%",
        // markers: true,
        // scrub: true
        scrub: 1,
        onStart: function () {
          thisImage.style.willChange = 'transform';
        },
        onComplete: function () {
          thisImage.style.willChange = 'auto';
        },
      }
    });
  });
  /*
    gsap.utils.toArray('.color-panel').forEach(section => {
      var thisImage = section;
      gsap.from(thisImage, {
        scaleX: .4,
        ease: 'Expo.Out',
        scrollTrigger: {
          trigger: section,
          toggleClass: 'enable',
          start: '0% 100%',
          end: "+=40%",
          // markers: true,
          // scrub: true
          scrub: 1,
          onStart: function() {
            thisImage.style.willChange = 'transform';
          },
          onComplete: function() {
            thisImage.style.willChange = 'auto';
          },
        }
      });
    });
  */
  gsap.utils.toArray('.img-wrapper').forEach(section => {
    var thisImage = section.querySelector('img');
    gsap.to(thisImage, {
      y: 60,
      // scale: 1.1,
      ease: 'Expo.Out',
      scrollTrigger: {
        trigger: section,
        toggleClass: 'enable',
        start: '0% 100%',
        end: "+=200%",
        // markers: true,
        // scrub: true
        scrub: 1,
        onStart: function () {
          thisImage.style.willChange = 'transform';
        },
        onComplete: function () {
          thisImage.style.willChange = 'auto';
        },
      }
    });
  });

  gsap.utils.toArray('.scroll-fade-in').forEach(section => {
    var thisElement = section;
    gsap.from(thisElement, {
      opacity: 0,
      y: 10,
      ease: 'Expo.Out',
      scrollTrigger: {
        trigger: section,
        toggleClass: 'enable',
        start: '0% 100%',
        end: "+=33%",
        // markers: true,
        scrub: 1,
        onStart: function () {
          thisElement.style.willChange = 'transform';
        },
        onComplete: function () {
          thisElement.style.willChange = 'auto';
        },
      }
    });
  });

  gsap.utils.toArray('.scroll-fade-in-date-picker').forEach(section => {
    var thisElement = section;
    gsap.from(thisElement, {
      y: 70,
      ease: 'Expo.inOut',
      scrollTrigger: {
        trigger: section,
        toggleClass: 'enable',
        start: '0% 98%',
        end: "+=25%",
        // markers: true,
        scrub: 1,
        onStart: function () {
          thisElement.style.willChange = 'transform';
        },
        onComplete: function () {
          thisElement.style.willChange = 'auto';
        },
      }
    });
  });


  /*
  gsap.utils.toArray('#results > div.horizontal-thumb .img-wrapper').forEach(section => {
    var thisImage = section.querySelector('img');
    gsap.fromTo(thisImage, {
      scale: 1.75,
    }, {
      scale: 1.8,

      ease: 'Expo.Out',
      scrollTrigger: {
        trigger: section,
        toggleClass: 'enable',
        start: '10% 30%',
        end: "+=65%",
        // markers: true,
        // scrub: true
        scrub: 1,
        onStart: function() {
          thisImage.style.willChange = 'transform';
        },
        onComplete: function() {
          thisImage.style.willChange = 'auto';
        },
      }
    });
  });



    gsap.utils.toArray('.bg').forEach(section => {
      var thisImage = section.querySelector('img');
      gsap.to(thisImage, {
        scale: 1.05,
        ease: 'Expo.Out',
        scrollTrigger: {
          trigger: section,
          toggleClass: 'enable',

          start: '10% 10%',
          end: "+=50%",
          // markers: true,
          // scrub: true
          scrub: 1,
          onStart: function() {
            thisImage.style.willChange = 'transform';
          },
          onComplete: function() {
            thisImage.style.willChange = 'auto';
          },
        }
      });

    });
  */

} // initSCrolling()

